import type { AppState } from '@store/types'

export const selectSubscription = (state: AppState) => state.subscription
